var _defs, _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCarPreloader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 423.89 443.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#152329;}.cls-2{fill:rgba(23, 152, 209, 1);}.cls-3{fill:#fefefe;}.cls-4{fill:#f7f7f7;}.cls-5{fill:rgba(23, 152, 209, .8);}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "car preloader") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 304.22,
    y: 204.15,
    width: 23.86,
    height: 41.99,
    rx: 4.91
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 386,
    y: 130.78,
    width: 23.86,
    height: 41.99,
    rx: 4.91
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M358.77,222.61c-2.13-2.33-4.11-4.56-6.16-6.73Q335,197.3,317.45,178.71a5.21,5.21,0,0,0-3.13-1.84,6.1,6.1,0,0,1-5.17-4.15c-3.21-9.51-11.1-15.71-16.62-23.57a4.28,4.28,0,0,0-1.36-1c-15.8-9.4-27.61-22.69-36.7-38.41-8.64-15-5.35-29,4.29-42.3,2.92-4,6.15-7.68,10.72-10,2.19-1.12,3.22-3.56,4.85-5.34a49.77,49.77,0,0,1,7.28-6.64,35.93,35.93,0,0,0,7.56-6.63c12.19-15.28,35.23-18.94,51.63-8.12a97.13,97.13,0,0,1,31.86,34.1c5.14,9.29,13.1,15.32,20,22.63,1.56,1.66,4.17,2.35,6.29,3.5,1.81,1,3.21,2.43,3.29,4.49.09,2.38,1.45,3.85,2.87,5.45q18.32,20.69,36.55,41.41c.7.8,1.43,1.57,2.3,2.52l6.9-10.23c2.16,3.41,2.64,6.69,1.42,10.1-.72,2-.22,3.29,1.21,4.82,8.36,8.9,16.3,18.21,24.93,26.83,12.38,12.36,13.7,35.26,4.11,49.79a122.1,122.1,0,0,1-37.7,36.45A111.66,111.66,0,0,1,433,269.25c-15.62,7.33-32.91,4.11-44.63-8.52-8.57-9.24-17-18.6-25.41-28-1.48-1.66-2.78-2.62-5.14-1.89-2.81.86-5.53.13-8.14-1.17-1.41-.7-1.58-1.21-.08-2C352.61,226.05,355.63,224.34,358.77,222.61Zm72.76-4.83,2.75-2.52c14.11-12.8,21.75-28.41,20.83-47.77a4.87,4.87,0,0,0-2-3.93c-9.61-7.66-19.21-15.33-28.71-23.12-1.59-1.31-2.06-.78-2.89.63-3.73,6.34-7.43,12.8-12.52,18.1-15.44,16.09-31.17,31.89-52.17,40.91-1.37.59-1.63,1.09-.68,2.48Q366.59,218,376.8,233.47a4.85,4.85,0,0,0,3.77,2.25,61.12,61.12,0,0,0,19.65-.55C412.91,232.81,423,225.81,431.53,217.78ZM283.21,114l-1.15,1c4,4.35,8.05,8.63,11.9,13.1,1.46,1.69,2,1.5,3.28-.2,6-8.08,11.74-16.32,18.93-23.46a176,176,0,0,1,39-29.54c1.74-1,2.29-1.53.6-3.2-8.69-8.57-17.27-17.24-25.86-25.91a2.83,2.83,0,0,0-2.54-1c-5.73.57-11.33,1.72-16.34,4.65a116.26,116.26,0,0,0-30.18,25.59c-5.45,6.42-9.42,13.42-10.93,21.75a3.78,3.78,0,0,0,.95,3.66C275,105,279.09,109.5,283.21,114Zm-5.65,9.85A239.66,239.66,0,0,0,301,156.53c20.92,24.18,43,47.31,65.24,70.23.57.58,1.2,1.1,2,1.82C342.17,189.58,313.31,153.37,277.56,123.85ZM352.87,55c26.29,38.32,59.75,70.28,96.33,99.73-.69-.89-1.12-1.51-1.61-2.08-21-24.38-42.16-48.54-64.53-71.67A242.68,242.68,0,0,0,352.87,55ZM482.71,194.37c-3,2.87-3.94,11.71-1.94,14.92,1.15,1.85,2.54,1.94,3.92.27,2.42-2.94,3.22-10.9,1.4-14.15C485.15,193.74,483.93,193.28,482.71,194.37Zm-62.78,74.46c1.67-1.25,1.58-2.69-.24-3.94-3-2.07-11.17-2-14.21.17-1.73,1.22-1.74,2.72,0,3.95C408.51,271.18,416.93,271.07,419.93,268.83ZM324.9,32c1.11-1,2-1.88,1.63-3.19s-1.43-1.54-2.48-1.7a16.28,16.28,0,0,0-12.3,3,2.73,2.73,0,0,0-1.4,3,2.66,2.66,0,0,0,2.47,1.72A16.79,16.79,0,0,0,324.9,32ZM257.13,94A16.72,16.72,0,0,0,261,82.11a2.64,2.64,0,0,0-1.53-2.59,2.58,2.58,0,0,0-2.84,1,16.15,16.15,0,0,0-4.29,12.19c.07,1.06.33,2.19,1.51,2.6S255.91,95,257.13,94Zm31.58-34c-2.2,2-4.41,4-6.61,6.06-.48.44-1.2,1-.69,1.66s1.21.06,1.68-.37q6.53-5.94,13-11.91c.47-.43,1.23-1,.51-1.63s-1.23.1-1.71.54C292.83,56.22,290.78,58.11,288.71,60Z",
    transform: "translate(-64.93 -24.44)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M431.53,217.78c-8.57,8-18.62,15-31.31,17.39a61.12,61.12,0,0,1-19.65.55,4.85,4.85,0,0,1-3.77-2.25Q366.57,218,356.18,202.56c-.95-1.39-.69-1.89.68-2.48,21-9,36.73-24.82,52.17-40.91,5.09-5.3,8.79-11.76,12.52-18.1.83-1.41,1.3-1.94,2.89-.63,9.5,7.79,19.1,15.46,28.71,23.12a4.87,4.87,0,0,1,2,3.93c.92,19.36-6.72,35-20.83,47.77Z",
    transform: "translate(-64.93 -24.44)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M283.21,114c-4.12-4.5-8.19-9-12.37-13.47a3.78,3.78,0,0,1-.95-3.66c1.51-8.33,5.48-15.33,10.93-21.75A116.26,116.26,0,0,1,311,49.53c5-2.93,10.61-4.08,16.34-4.65a2.83,2.83,0,0,1,2.54,1c8.59,8.67,17.17,17.34,25.86,25.91,1.69,1.67,1.14,2.24-.6,3.2a176,176,0,0,0-39,29.54c-7.19,7.14-12.95,15.38-18.93,23.46-1.26,1.7-1.82,1.89-3.28.2-3.85-4.47-7.92-8.75-11.9-13.1Z",
    transform: "translate(-64.93 -24.44)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M277.56,123.85c35.75,29.52,64.61,65.73,90.65,104.73-.79-.72-1.42-1.24-2-1.82-22.28-22.92-44.32-46-65.24-70.23A239.66,239.66,0,0,1,277.56,123.85Z",
    transform: "translate(-64.93 -24.44)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M352.87,55a242.68,242.68,0,0,1,30.19,26c22.37,23.13,43.56,47.29,64.53,71.67.49.57.92,1.19,1.61,2.08C412.62,125.23,379.16,93.27,352.87,55Z",
    transform: "translate(-64.93 -24.44)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M482.71,194.37c1.22-1.09,2.44-.63,3.38,1,1.82,3.25,1,11.21-1.4,14.15-1.38,1.67-2.77,1.58-3.92-.27C478.77,206.08,479.74,197.24,482.71,194.37Z",
    transform: "translate(-64.93 -24.44)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M419.93,268.83c-3,2.24-11.42,2.35-14.47.18-1.72-1.23-1.71-2.73,0-3.95,3-2.15,11.21-2.24,14.21-.17C421.51,266.14,421.6,267.58,419.93,268.83Z",
    transform: "translate(-64.93 -24.44)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M324.9,32a16.79,16.79,0,0,1-12.08,2.8,2.66,2.66,0,0,1-2.47-1.72,2.73,2.73,0,0,1,1.4-3,16.28,16.28,0,0,1,12.3-3c1.05.16,2.16.51,2.48,1.7S326,31,324.9,32Z",
    transform: "translate(-64.93 -24.44)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M257.13,94c-1.22,1.07-2.12,1.71-3.26,1.32s-1.44-1.54-1.51-2.6a16.15,16.15,0,0,1,4.29-12.19,2.58,2.58,0,0,1,2.84-1A2.64,2.64,0,0,1,261,82.11,16.72,16.72,0,0,1,257.13,94Z",
    transform: "translate(-64.93 -24.44)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M288.71,60c2.07-1.88,4.12-3.77,6.2-5.65.48-.44,1.09-1.11,1.71-.54s0,1.2-.51,1.63q-6.5,6-13,11.91c-.47.43-1.09,1.14-1.68.37s.21-1.22.69-1.66C284.3,64,286.51,62,288.71,60Z",
    transform: "translate(-64.93 -24.44)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 187.58,
    cy: 22.12,
    r: 8.94
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 150.06,
    cy: 33.5,
    r: 16.24
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 113.29,
    cy: 52.66,
    r: 14.88
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 79.55,
    cy: 79.29,
    r: 13.45
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 52.42,
    cy: 110.94,
    r: 11.71
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 30.79,
    cy: 146.87,
    r: 10.63
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 16.32,
    cy: 186.67,
    r: 9.38
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 8.46,
    cy: 228.17,
    r: 8.46
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 8.68,
    cy: 270.02,
    r: 7.97
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 16.2,
    cy: 311.54,
    r: 6.91
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 30.73,
    cy: 350.76,
    r: 5.77
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 52.56,
    cy: 387.21,
    r: 4.69
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 80.14,
    cy: 418.48,
    r: 4.07
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 109.54,
    cy: 440.92,
    r: 2.97
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarPreloader);
export default __webpack_public_path__ + "static/media/car-preloader.42eb70ab5f2e9c404d839b66207b8d6c.svg";
export { ForwardRef as ReactComponent };